<template>
  <div class="flex items-center justify-center w-full m-auto" style="height: 40vh">
    <div class="w-30">
      <div id="loader" class="w-24 h-24" ref="loader"></div>
      <p class="text-brand-green text-center">Loading...</p>
    </div>
  </div>
</template>
<script>
import lottie from "lottie-web"
import loading from "./Loading.json"

export default {
  mounted() {
    this.animation = lottie.loadAnimation({
      container: this.$refs.loader,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: loading
    })
  },
  data() {
    return {
      animation: null
    }
  },
  unmounted() {
    this.animation.destroy()
  }
}
</script>
